export const LAYOUT_TYPES = {
    STACK: 'stack',
    FILL: 'fill',
    ABSOLUTE: 'absolute'
};

export const LAYOUT_ORIENTATION = {
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal'
};
